// Bosluklari ve bastaki 0'i atar: "0532 123 45 67" -> "5321234567"
export function normalizeGsm(value) {
  if (value === null || value === undefined) return '';
  let text = String(value).replace(/ /g, '');
  if (text.indexOf('0') === 0) text = text.substring(1);
  return text;
}

// Satirda dolu bir GSM var ve sistemdeki esli hattan farkliysa true
export function hasGsmConflict(value, pairedGsm) {
  const current = normalizeGsm(value);
  const paired = normalizeGsm(pairedGsm);
  return current !== '' && paired !== '' && current !== paired;
}

// Hattin esli oldugu cihaz, satirdaki seri no mu?
// Seri no cihaz kaydinda IMEI_NO'dadir; eski kayitlarin bir kisminda DEVICE_ID, IMEI_NO'nun son 7 hanesidir.
// Son 7 hane baska bir cihazla da tutabilecegi icin IMEI_NO varsa yalnizca ona bakilir.
export function isHatOnDevice(hat, serial) {
  if (!hat || !hat.DEVICE_ID || !serial) return false;

  const deviceSerial = String(serial).trim();
  const imei = hat.IMEI_NO ? String(hat.IMEI_NO).trim() : '';
  if (imei) return imei === deviceSerial;

  const deviceId = String(hat.DEVICE_ID).trim();
  return deviceId === deviceSerial ||
    (deviceId.length === 7 && deviceSerial.length === 15 && deviceSerial.slice(-7) === deviceId);
}



// WEBPACK FOOTER //
// ./src/utils/gsm.js